

<template>
    <div class="warehouse_add_wrap">
        <div class="warehouse_add_top">
            <div class="warehouse_add_code_identification">
                <div><span v-if="related_info && related_info.related_num">业务编号：<span class="template_color" v-text="related_info.related_num" @click="handleClickRelatedDetail"></span></span></div>
                <el-button v-if="!pending_info || (pending_info.related_type != 'purchase' && pending_info.stock_type != 'transfer_in' && pending_info.stock_type != 'transfer_in_cancel')"  size="small" type="primary" @click="handleClickCodeIdentification">编码识别</el-button>
            </div>

            <div class="warehouse_add_table">
                <el-table class="custom_table" :data="formData.productData" border row-id="related_id"  ref="table" :span-method="arraySpanMethod" >
                    <el-table-column v-if="pending_info && pending_info.biz_type == 'order'" label="售卖产品" prop="goods_name"  key="goods_name" show-overflow-tooltip  min-width="220px">
                        <template slot-scope="{row}">
                            <div v-if="row.goods_info" class="bundle_wrap">
                                <div v-if="row.goods_info.goods_type == 'bundle'">
                                    <h5 >
                                        {{row.goods_info.goods_name}} <span class="danger_text" v-text="row.goods_info.type == 1 ? '(销售)' : '(租借)'"></span>
                                    </h5>
                                    <p   v-for="child in row.goods_info._child" v-text="child.goods_name"></p>
                                </div>
                                <div v-else>
                                    {{row.goods_info.goods_name}} <span  class="danger_text"  v-text="row.goods_info.type == 1 ? '(销售)' : '(租借)'"></span>
                                </div>
                            </div>

                        </template>
                    </el-table-column>
                    <el-table-column label="产品名称" prop="name" key="name" show-overflow-tooltip  class-name=" tableInputColumn"	 min-width="434px">
                        <template slot-scope="{row}">
                            <p class="ellipsis" v-text="row.name" ></p>
                        </template>
                    </el-table-column>
                    <el-table-column label="待入库数量" prop="audit_num" key="audit_num" show-overflow-tooltip  width="120px" >
                        <template slot-scope="{row}">
                            <span v-text="row.audit_num" ></span>
                        </template>
                    </el-table-column>
                    <el-table-column label="单位" prop="unit" key="unit" show-overflow-tooltip  width="80px" class-name=" tableInputColumn" >
                        <template slot-scope="{row}">
<!--                            <el-input v-if="!row.is_unit" type="mini" v-model="row.unit" placeholder="请输入" ></el-input>-->
                            <span  v-text="row.unit" ></span>
                        </template>
                    </el-table-column>
                    <el-table-column v-if="pending_info && pending_info.biz_type == 'purchase'" align="right" label="单价（元）" prop="cost_price" key="cost_price" show-overflow-tooltip  width="96px" ></el-table-column>

                    <el-table-column label="入库仓库" prop="in_stock_id"   width="226px" class-name="tableInputColumn">
                        <template #header>
                            <span style="margin-right: 4px">入库仓库</span>
                            <el-popover placement="bottom" ref="stockPopover" >
                                <span slot="reference">
                                    <el-tooltip class="item" content="批量入库" effect="dark" placement="top">
                                        <span class="handle_icon_wrap"><i class="iconfont icon-a-tianjiamiaobian"></i></span>
                                    </el-tooltip>
                                </span>
                                <el-select  @change="handleChangeProductStockAll($event)" :disabled="pending_info && pending_info.stock_type == 'transfer_in'"  class="tableInput" placeholder="请选择入库仓库"  remote  reserve-keyword v-model="stock_id">
                                    <el-option :key="item.stock_id" :label="item.name" :value="item.id" v-for="item in stockList"> </el-option>
                                </el-select>
                            </el-popover>
                        </template>
                        <template slot-scope="{row}">
                            <el-select v-model="row.stock_id" placeholder="请选择入库仓库" :disabled="pending_info && pending_info.stock_type == 'transfer_in'">
                                <el-option :key="item.stock_id" :label="item.name" :value="item.id" v-for="item in stockList"> </el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column label="入库数量/产品编码" prop="no_code_num" key="no_code_num" min-width="332px"  class-name="tableInputColumn">
                        <template slot-scope="{row}">
                         <div class="product_num_code">
                            <el-input type="mini" v-model="row.no_code_num" placeholder="请输入数量" :disabled="(row.loss_num || (pending_info.biz_type == 'order' && !row.audit_no_code_num))  ? true : false" @change="handleChangeNum(row)"></el-input>
                            <div class="line"></div>
                            <div class="change_code">
                                <el-popover  placement="bottom"  popper-class="product_code_popper" title=""  width="226"  trigger="hover">
                                            <span class="change_code_wrap" slot="reference" @click="handleClickSelectCode(row)">
                                               <i class="el-icon-circle-plus-outline"></i>
                                               <span v-text="pending_info.stock_type == 'transfer_in' || pending_info.stock_type == 'transfer_in_cancel' ? '选择编码' :'输入编码'"></span>
                                            </span>
                                    <div class="product_code_wrap" >
                                        <ul>
                                            <li class="ellipsis" v-for="item in row.code_list" v-text="item"></li>
                                        </ul>
                                        <div class="code_num_wrap">
                                            共：{{row.code_num}}条
                                        </div>
                                    </div>
                                </el-popover>
                            </div>
                            <div class="total_num">
                                共<span v-if="row.total_num" v-text="row.total_num"></span>
                            </div>
                        </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="58" align="center" v-if="pending_info && pending_info.stock_type != 'transfer_in' && pending_info.stock_type != 'transfer_in_cancel'">
                        <template slot-scope="{row,$index}">
                            <el-button type="text" @click="handleClickInLoss(row)" class="danger_text">丢失</el-button>
                        </template>
                    </el-table-column>
                </el-table>

            </div>

            <div class="warehouse_add_from">
                <el-form ref="formData"  :model="formData"  :rules="formDataRules"  label-position="top"  size="small">
                    <el-form-item label="附件" class="label-bold" prop="file_list">
                        <div class="file_upload_wrap">
                            <div v-if="formData.file_list.length===0" class="file_outer_wrap">
                                <img alt=""  src="https://download.hecoos.com/enlightv/2023-31/3wy8ZnscPAjXMD2XmQhb.png"  width="36">
                                <p class="file_hint">点击或者将文件拖拽到这里上传</p>
                                <p class="file_type_hint">支持.rar .zip .doc .docx .pdf .jpg...</p>
                                <input class="upload_input"  multiple type="file" @change="handleUploadFileChange($event)">
                            </div>
                            <ul v-else class="upload_file_list">
                                <li v-for="file in formData.file_list" class="upload_file_item">
                                    <div class="file_left_wrap">
                                        <img alt="" class="file_img"  src="https://download.hecoos.com/enlightv/2023-37/chyZ4zyQiQkR5byRwSCT.png">
                                        <div class="file_info_wrap">
                                            <p class="file_name" v-text="file.file_name"></p>
                                            <p class="file_size" v-text="file.file_size"></p>
                                        </div>
                                    </div>
                                    <div class="file_right_wrap">
                                        <el-tooltip content="预览"  effect="dark"  placement="top">
                                            <span class="handle_icon_wrap" @click="handleClickPreview(file)">
                                                <i class="iconfont icon-yanjing"></i>
                                            </span>
                                        </el-tooltip>
                                        <span class="line"></span>
                                        <el-tooltip content="删除"  effect="dark"  placement="top">
                                            <span class="handle_icon_wrap handle_icon_danger_wrap"  @click="formData.file_list.splice(file_idx,1)">
                                                <i class="iconfont icon-shanchu1"></i>
                                            </span>
                                        </el-tooltip>
                                    </div>
                                </li>
                                <li class="upload_file_btn_wrap">
                                    <i class="el-icon-plus"></i>
                                    <span>添加附件</span>
                                    <input class="upload_input"  multiple  type="file"  @change="handleUploadFileChange($event)">
                                </li>
                            </ul>
                        </div>
                    </el-form-item>
                    <el-form-item label="备注信息" class="label-bold" prop="note">
                        <el-input type="textarea" :rows="5" v-model="formData.note" placeholder="请输入备注信息"></el-input>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="warehouse_add_bottom">
            <el-button size="small" @click="handleClickClose">取消</el-button>
            <el-button :disabled="btnDisabled" size="small" type="primary" @click="handleClickConfirm">提交</el-button>
        </div>
        <CodeIdentification :codeIdentificationDialog.sync="codeIdentificationDialog" v-if="codeIdentificationDialog" :sourceType="'in'"  :relatedType="pending_info.related_type" :related_info="related_info" :productInfo="productInfo" :selectedCodeData="selectedCodeData" :maxCodeIdentification="maxCodeIdentification" @success="selectCodeSuccess" />
        <InLossProduct :inLossDialog.sync="inLossDialog" v-if="inLossDialog"  :productInfo="productInfo" @success="lossSuccess"/>
        <PurchaseDetail :purchaseDetailVisible.sync="purchaseDetailVisible" v-if="purchaseDetailVisible" :purchaseId="related_info.related_id"/>
        <SelectCode v-if="selectCodeDialog" :productInfo="productInfo" :selectCodeDialog.sync="selectCodeDialog" :relatedId="related_info.related_id" :stockType="pending_info.stock_type" @success="selectCodeSuccess"></SelectCode>
        <el-image :preview-src-list="previewImgList" :src="previewImgSrc" ref="preview_img" style="display: none"></el-image>
    </div>
</template>
<script>
import {pendingInDetail,stockList,pendingIn,stockCheckLoss,codeInGetProduct} from "@/api/index.js"
import {formatFileSize,removeTag} from "@/utils";
import {getOSSData, uploadImg} from "@/utils/uploadOss";
import CodeIdentification from  "../component/code_identification"
import InLossProduct from  "./component/in_loss_product"
import PurchaseDetail from "../../Purchase/component/purchase_detail"; //采购详情
import SelectCode from  "../component/select_code"
import {EventBus} from '@/utils/eventBus';
export default {
    name: 'InWarehouseAudit',
    components: {
        CodeIdentification,
        InLossProduct,
        PurchaseDetail,
        SelectCode
    },
    data() {
        return {
            loading:false,
            stock_pending_id:0,
            btnDisabled:false,
            formData:{
                productData:[],
                file_list:[],
                note:''
            },
            formDataRules:{},
            stock_id:'',
            stockOptions:[],
            codeIdentificationDialog:false, //选择编码/编码识别
            maxCodeIdentification:null, //最大识别编码数量
            productInfo:null,//选中的产品
            productId:0,
            inLossDialog:false,

            related_info:null,
            pending_info:null,
            stockList:[],
            purchaseDetailVisible:false,//采购详情
            selectCodeDialog:false,
            selectedCodeData:[],
            previewImgList: [],
            previewImgSrc: "",
            default_bring:['transfer_in','transfer_in_cancel']
        }
    },

    mounted() {

    },
    created() {
        this.getStockList()
        this.stock_pending_id = this.$route.query.stock_pending_id
        if(this.stock_pending_id){
            this.getPendingInDetail()
        }
    },
    methods: {
        // 获取详情
        getPendingInDetail(){
            pendingInDetail({ stock_pending_id:this.stock_pending_id }).then(res => {
                if (res.code === 200) {
                    let {related_info,product_list,pending_info,goods_list} = res.data
                    this.related_info = related_info
                    this.related_info.stock_pending_id = this.stock_pending_id
                    goods_list.forEach(item => {
                        item.goodsChildIds = []
                        if(item._child){
                            item.goodsChildIds = item._child.map(child => child.order_goods_id)
                        }
                        item.goodsChildIds.push(item.order_goods_id)
                    })
                   let productData  = product_list.map(item => {
                        let goods_info = null
                        if(pending_info.biz_type == 'order'){
                            goods_info = goods_list.find(find => find.goodsChildIds.indexOf(item.related_detail_id) > -1)
                            let goods_id = item.related_detail_id == goods_info.order_goods_id ? goods_info.goods_id : goods_info._child.find(child => child.order_goods_id == item.related_detail_id).goods_id
                            let goods_sku_id = item.related_detail_id == goods_info.order_goods_id ? goods_info.goods_sku_id : goods_info._child.find(child => child.order_goods_id == item.related_detail_id).goods_sku_id
                            let audit_code_num = item.related_detail_id == goods_info.order_goods_id ? goods_info.code_num : goods_info._child.find(child => child.order_goods_id == item.related_detail_id).code_num
                            let audit_no_code_num = item.related_detail_id == goods_info.order_goods_id ? goods_info.no_code_num : goods_info._child.find(child => child.order_goods_id == item.related_detail_id).no_code_num
                            return {
                                audit_code_num, //待入库的编码数量
                                audit_no_code_num,//待入库的无编码数量
                                goods_id,
                                goods_sku_id,
                                goods_info:goods_info,
                                related_detail_id:item.related_detail_id,
                                loss_num:0,
                                loss_note:'',
                                name:item.product_name,
                                stock_pending_product_id:item.stock_pending_product_id,
                                related_type:item.related_type,
                                related_id:item.related_id,
                                sku_id:item.sku_id,
                                sku_key:item.sku_key,
                                unit:item.unit,
                                is_unit:item.unit ? true :false,
                                cost_price:item.cost_price,
                                stock_id:item.stock_id ? item.stock_id : '',
                                audit_num:item.num,//待入库数量
                                no_code_num:0, //输入的无编码数量
                                code_num: 0, //选择的有编码数量
                                code_list: [], //选择的编码
                                total_num: 0, //选择的总数量
                                not_found_code:[], // 不存在的编码
                                unmatched_code:[],//已存在未绑定的编码
                            }
                        }else{
                            return {
                                loss_num:0,
                                loss_note:'',
                                name:item.product_name,
                                related_detail_id:item.related_detail_id ? item.related_detail_id : 0,
                                stock_pending_product_id:item.stock_pending_product_id,
                                related_type:item.related_type,
                                related_id:item.related_id,
                                sku_id:item.sku_id,
                                sku_key:item.sku_key,
                                unit:item.unit,
                                is_unit:item.unit ? true :false,
                                cost_price:item.cost_price,
                                stock_id:item.stock_id ? item.stock_id : '',
                                audit_num:item.num,//待入库数量
                                no_code_num:((pending_info.stock_type == 'transfer_in' || pending_info.stock_type == 'transfer_in_cancel') && item.no_code_num) ? item.no_code_num : 0, //输入的无编码数量
                                code_num:((pending_info.stock_type == 'transfer_in' || pending_info.stock_type == 'transfer_in_cancel') && item.code_num) ? item.code_num : 0, //选择的有编码数量
                                code_list:((pending_info.stock_type == 'transfer_in' || pending_info.stock_type == 'transfer_in_cancel') && item.code_list) ? item.code_list : [], //选择的编码
                                all_code_list:((pending_info.stock_type == 'transfer_in' || pending_info.stock_type == 'transfer_in_cancel' ) && item.code_list) ? item.code_list : [], //转移入库时可选择的编码
                                total_num:(pending_info.stock_type == 'transfer_in' || pending_info.stock_type == 'transfer_in_cancel') ? Number(item.no_code_num) + Number(item.code_num) : 0, //选择的总数量

                                audit_code_num:((pending_info.stock_type == 'transfer_in' || pending_info.stock_type == 'transfer_in_cancel') && item.no_code_num) ? item.no_code_num : 0,  //待入库的无编码数量
                                audit_no_code_num:((pending_info.stock_type == 'transfer_in' || pending_info.stock_type == 'transfer_in_cancel') && item.code_num) ? item.code_num : 0, //待入库的编码数量
                                not_found_code:[], // 不存在的编码
                                unmatched_code:[],//已存在未绑定的编码
                            }
                        }

                    })

                    if(pending_info.biz_type == 'order') {
                        productData.sort((a, b) => {
                            return a.goods_id - b.goods_id; // 升序排序
                        });
                    }

                    this.formData.productData = productData
                    this.pending_info = pending_info
                    this.$nextTick(()=>{
                        this.$refs.table.doLayout()
                   })

                }
            })
        },
        // 订单时商品合并单元格
        arraySpanMethod({ row, column, rowIndex, columnIndex }) {
            if(this.pending_info.biz_type == 'order'){
                if (columnIndex === 0) {
                    const currentId = row.goods_info.order_goods_id;
                    const prevId = rowIndex > 0 ? this.formData.productData[rowIndex - 1].goods_info.order_goods_id : null;
                    const nextId = rowIndex < this.formData.productData.length - 1 ? this.formData.productData[rowIndex + 1].goods_info.order_goods_id : null;
                    // 如果当前行的 ID 和上一行的 ID 不同，则合并
                    if (currentId !== prevId) {
                        // 统计当前 ID 连续出现的次数
                        let spanCount = 1;
                        for (let i = rowIndex + 1; i < this.formData.productData.length; i++) {
                            if (this.formData.productData[i].goods_info.order_goods_id === currentId) {
                                spanCount++;
                            } else {
                                break;
                            }
                        }
                        return [spanCount, 1]; // 合并行数
                    } else {
                        return [0, 0]; // 不显示单元格
                    }
                }
            }
        },
        // 获取仓库
        getStockList(){
            stockList({}).then(res => {
                if (res.code === 200) {
                    this.stockList = res.data
                }
            })
        },
        // 编码识别
        handleClickCodeIdentification(){
            this.productId = 0
            this.productInfo = null
            this.selectedCodeData = []
            this.formData.productData.forEach(item =>{
                this.selectedCodeData = this.selectedCodeData.concat(item.code_list)
            })
            this.codeIdentificationDialog = true
        },
        getProductStock(){

        },
        // 输入数量
        handleChangeNum(row){
            const num = row.no_code_num;
            const regex = /^[1-9]\d*$/; // 正整数的正则表达式
            if (!regex.test(num)) {
                this.$set(row,'no_code_num',0)
            } else {
                if(this.pending_info.biz_type == 'order' || this.pending_info.stock_type == 'transfer_in' || this.pending_info.stock_type == 'transfer_in_cancel'){
                    // 如果是订单 / 转移 的时候，如果输入的无编码数量大于待办的无编码数量，则等于待办的无编码数量
                    if(row.no_code_num > row.audit_no_code_num){
                        this.$set(row,'no_code_num',row.audit_no_code_num)
                    }
                }
                // 如果输入的数量大于待入库总数量则等于总数量
                let total_num = Number(row.no_code_num) + Number(row.code_num) + Number(row.loss_num)
                if(total_num > row.audit_num){
                    this.$set(row,'no_code_num',Number(row.audit_num) - Number(row.code_num) - Number(row.loss_num))
                }

            }
            this.$nextTick(()=>{
             this.$set(row,'total_num',Number(row.no_code_num) + Number(row.code_num))
            })
        },
        // 选择产品编码
        handleClickSelectCode(row){
            if(row.loss_num){return this.$message.error('该产品已操作丢失')}
            this.productInfo = row
            this.selectedCodeData = []
            this.formData.productData.forEach(item =>{
                this.selectedCodeData = this.selectedCodeData.concat(item.code_list)
            })
            // 如果是转移入库的话
            if(this.pending_info.stock_type == 'transfer_in' ||this.pending_info.stock_type == 'transfer_in_cancel'){
                if(row.all_code_list.length == 0){
                    return  this.$message.error('该产品入库数量/产品编码合计不可超过待入库数量')
                }
                this.selectCodeDialog = true
            }else{
                let maxCodeIdentification = row.audit_num - row.total_num
                // if(maxCodeIdentification == 0){
                //    return  this.$message.error('该产品入库数量/产品编码合计不可超过待入库数量')
                // }
                this.maxCodeIdentification =    maxCodeIdentification
                this.codeIdentificationDialog = true
            }
        },
        // 选择编码后回调
        selectCodeSuccess(data){
            this.maxCodeIdentification = null
            // 如果是转移入库  转移取消入库 的话
            if(this.pending_info.stock_type == 'transfer_in' || this.pending_info.stock_type == 'transfer_in_cancel'){
                this.$set(this.productInfo,'code_list',data.map(item => item.code))
                this.$set(this.productInfo,'code_num',this.productInfo.code_list.length)
                this.$set(this.productInfo,'total_num',Number(this.productInfo.no_code_num) + Number(this.productInfo.code_num))

            }else{
                if(this.productInfo && this.productInfo.name){
                    let {code_list, selected_code_list, not_found_code, unmatched_code} = data
                    this.$set(this.productInfo,'code_list',selected_code_list.concat(code_list)) //已选的+ 新增的
                    this.$set(this.productInfo,'not_found_code',this.productInfo.not_found_code.concat(not_found_code)) //不存在的
                    this.$set(this.productInfo,'unmatched_code',this.productInfo.unmatched_code.concat(unmatched_code)) //存在没绑定
                    this.$set(this.productInfo,'code_num',this.productInfo.code_list.length)
                    this.$set(this.productInfo,'total_num',Number(this.productInfo.no_code_num) + Number(this.productInfo.code_num))
                }else{

                    this.loading = true
                    let code_list = []
                    this.formData.productData.forEach((item, key) => {
                        let code = item.code_list.map(map => map.code)
                        code_list = [...code_list, ...code]
                    })
                    let codeList = data.code_list.filter(item => !code_list.includes(item));
                    if(codeList.length != data.code_list.length){
                        this.$message.error('检查到有重复的编码已经为您去重')
                    }
                    if(codeList.length == 0){this.loading = false;  return  false }

                    codeInGetProduct({code_list:codeList,related_type:this.related_info.related_type,related_id:this.related_info.related_id}).then(res => {
                        if (res.code === 200) {
                            let {data} = res
                            data.forEach((item,key)=>{
                                this.mergeProductFunction(item)
                            })
                        }
                        this.loading = false
                    })


                }
            }
        },

        mergeProductFunction(row){
            if(this.formData.productData.length>0){
                this.formData.productData.forEach((item, index) => {
                    if(item.name == row.name && item.sku_id == row.sku_id && item.sku_key == row.sku_key && item.related_detail_id == row.related_detail_id){
                        this.$set(item,'code_list',item.code_list.concat(row.code_list))
                        this.$set(item,'code_num',item.code_list.length)
                        this.$set(item,'total_num',Number(item.code_num) + Number(item.no_code_num))
                    }
                })
            }
        },

        // 批量选择仓库
        handleChangeProductStockAll($event){
            this.formData.productData.forEach(item => {
                this.$set(item,'stock_id',$event)
            })
            this.$forceUpdate()
            this.$refs.stockPopover.doClose()
        },
        // 丢失
        handleClickInLoss(row){
            let postData = {
                biz_type : this.related_info.related_type,
                biz_type_id : this.related_info.related_id,
                related_detail_id: row.order_goods_id ? row.order_goods_id : row.related_id,  //非订单类：stock_pending_products 表的 related_id 订单类：为 order_goods_id
                goods_id : row.goods_id ? row.goods_id : 0, // 非订单类：goods_id = 0
                goods_sku_id : row.goods_sku_id ? row.goods_sku_id : 0,// 非订单类：goods_sku_id = 0
            }
            stockCheckLoss(postData).then(res => {
                if (res.code === 200) {
                    this.productInfo = row
                    this.inLossDialog = true
                }
            })
        },
        // 丢失回调
        lossSuccess(data){
            this.productInfo.loss_num = data.loss_num
            this.productInfo.loss_note = data.loss_note
        },


        // 上传附件
        handleUploadFileChange(e){
            const files = e.target.files
            const that = this;
            Array.from(files).forEach(file => {
                uploadImg(file, 50).then(res => {
                    if (res.file_path) {
                        res.file_size = formatFileSize(file.size)
                        this.formData.file_list.push(res)
                        e.target.value = ''
                    }
                    e.target.value = ''
                }).catch(error => {
                    e.target.value = ''
                })
            })
        },
        // 预览
        handleClickPreview(file){
            if (file.file_type.indexOf("image") > -1) {
                this.previewImgList = [file.file_path];
                this.previewImgSrc = file.file_path;
                this.$refs.preview_img.showViewer = true;
            } else {
                if (file.file_type.indexOf("pdf") > -1) {
                    window.open(file.file_path);
                } else {
                    this.$message.error("当前文件格式不支持预览，请下载后查看");
                }
            }
        },
        handleClickClose(){
            if (this.formData.note || this.formData.file_list.length > 0 || this.formData.productData.filter(item => (item.stock_id || item.total_num)).length>0 ){
                const h = this.$createElement;
                this.$msgbox({
                    title: '取消',
                    message: h('div', null, [
                        h('span', null, '取消后，编辑内容不保留，是否取消！'),
                    ]),
                    iconClass: `icon-jinggao iconfont prompt_message_icon status1`,
                    customClass: 'prompt_message_custom',
                    confirmButtonText:   '是',
                    closeOnClickModal: false,
                    closeOnPressEscape: false,
                    cancelButtonText:   '否',
                    showCancelButton: true,
                    confirmButtonClass:  'el-button--primary',
                    beforeClose: (action, instance, done) => {
                        if (action === 'confirm') {
                            done();
                        } else {
                            done();
                        }
                    }
                }).then(() => {
                    removeTag(this.$route)
                    this.$router.go(-1);
                }).catch(() => {
                })
            }else{
                removeTag(this.$route)
                this.$router.go(-1);
            }
        },
        handleClickConfirm(){
            this.$refs.formData.validate((valid) => {
                if (valid) {
                    let flag = false
                    let product_list = JSON.parse(JSON.stringify(this.formData.productData))
                    let post_product_list = []
                    product_list.forEach((item,index) => {
                        if(this.pending_info.biz_type == 'order'){
                            delete item.cost_price
                        }
                        delete item.is_unit
                        delete item.audit_num
                        delete item.audit_code_num
                        delete item.audit_no_code_num
                        delete item.all_code_list
                        if(!item.stock_id && item.total_num && !flag ){
                            this.$message.error('请选择入库仓库')
                            flag = true
                        }
                        if((item.total_num && item.stock_id) || item.loss_num){
                            if((item.stock_id && !item.total_num) || (!item.stock_id && item.total_num) ){
                                item.stock_id = ''
                                item.total_num = 0
                            }
                            post_product_list.push(item)
                        }
                    })

                    if(flag){return  false}
                    if(post_product_list.length == 0){return this.$message.error('请至少入库一个产品')}
                    let postData = {
                        product_list:post_product_list,
                        files:this.formData.file_list,
                        note:this.formData.note,
                        stock_pending_id:this.stock_pending_id,

                        stock_type:this.pending_info.stock_type,
                        approval_id:this.pending_info.approval_id,
                        approval_uid:this.pending_info.uid,
                        // approval_type:this.pending_info.approval_type,
                        // approval_set_id:this.pending_info.approval_set_id,
                        related_type:this.related_info.related_type,
                        related_id:this.related_info.related_id,
                        related_num:this.related_info.related_num,
                    }


                    const h = this.$createElement;
                    this.$msgbox({
                        title: '提交入库',
                        message: h('div', null, [
                            h('span', null, '确定执行入库操作吗？ \r\n 提交后无法撤回，请谨慎操作。'),
                        ]),
                        iconClass: `icon-jinggao iconfont prompt_message_icon status1`,
                        customClass: 'prompt_message_custom',
                        confirmButtonText:  '确定',
                        closeOnClickModal: false,
                        closeOnPressEscape: false,
                        showCancelButton: true,
                        confirmButtonClass:  'el-button--primary',
                        beforeClose: (action, instance, done) => {
                            if (action === 'confirm') {
                                done();
                            } else {
                                done();
                            }
                        }
                    }).then(() => {
                        this.btnDisabled = true
                        pendingIn(postData).then(res => {
                            if (res.code === 200) {
                                this.$message({
                                    type: 'success',
                                    message:'入库成功',
                                    duration: 1500,
                                    onClose: () => {
                                        EventBus.$emit('inventoryInUpdated');
                                        removeTag(this.$route)
                                        this.$router.go(-1);
                                        this.btnDisabled = false
                                    }
                                })
                            }else{
                                this.btnDisabled = false
                            }
                        })
                    }).catch(() => {
                    })
                }
            })
        },

        // 关联详情
        handleClickRelatedDetail(row){
            if(this.pending_info.related_type == 'purchase'){
                this.purchaseDetailVisible = true
            }else if(this.pending_info.biz_type == 'order'){
                this.$router.push({
                    name: "OrderDetail",
                    params: {
                        isPush: true,
                    },
                    query: {
                        order_id:this.related_info.related_id,
                        name:this.related_info.related_num,
                    },
                });
            }
        },
    },
}
</script>

<style lang="scss" scoped >
@import "@/styles/inventory_management.scss";
.bundle_wrap{
    width: 100%;
    h5{
        line-height: 22px;
        color: rgba(51, 51, 51, 1);
        font-size: 14px;
        font-weight: bold;
        padding-bottom: 4px;
        border-bottom: 1px solid rgba(232, 232, 232, 1);
        margin-bottom: 4px;
    }
    p{
        line-height: 18px;
        font-size: 12px;
        color: rgba(102, 102, 102, 1);
    }
}
</style>